import(/* webpackMode: "eager" */ "/app/apps/consumer/app/(public)/login/page.tsx");
